import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBigPicklistInput } from '@facet-wealth/design';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('discussionTopics', {
    _component: () => FDBigPicklistInput,
    _customProps: {
      helperText: '',
      multiple: true,
    },
  }, overrideReadOnly)
  .nameOverride('userEnteredDiscussionTopic', {
    _customProps: {
      multiline: true,
      rows: 5,
      fullWidth: true,
    },
  }, overrideReadOnly)
  .done();

const WhatToDiscussStepTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

WhatToDiscussStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default WhatToDiscussStepTemplate;
